import React, { useContext, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import { _Autocomplete, _DateField, _NumberField, _Select } from "../../form";
import { _Button, _ButtonAPI, _Dialog } from "..";
import useToggle from "../../../hooks/Toggle";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IDerogationProps {
    Data: Dati.TListaParametriDeroga;
    Id: number;
    Type: string;
}

export const _Derogation: React.FC<IDerogationProps> = ({ Data, Id, Type }) => {
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Note, setNote] = useState("");
    const [Fields, setFields] = useReducerOnChange<Dati.TListaParametriDeroga>(Data);
    const { open, toggle } = useToggle();

    useEffect(() => {
        setFields({ Type: "Set", Value: Data });
    }, [Data]);

    const OnChangeNote = (e: React.FormEvent<any>) => {
        setNote(e.currentTarget.value);
    };

    const onClickDerogation = (data: Dati.CRisAPI) => {
        toggle();

        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("DEROGA", Trad.Trad("Richiesta deroga inserita correttamente"), "success");
        }
    };

    const GetFormData = (): any => ({
        Tipo: Type,
        ListaValori: Fields,
        Note: Note,
        ID: Id
    });

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    return (
        <>
            <_Dialog
                Open={open}
                Title={`${Trad.Trad("Deroga")}: ${Trad.Trad(Type)}`}
                Type="info"
                OnClose={toggle}
                Actions={<_ButtonAPI URL="/api/Deroga" Testo={Trad.Trad("Richiedi")} OnInvio={GetFormData} OnClick={onClickDerogation} OnErrore={OnApiError} />}
            >
                <form noValidate>
                    <Grid container justify="center" spacing={4}>
                        {Object.keys(Fields).map(fieldName => (
                            <Grid item xs={12} key={fieldName}>
                                <_NumberField
                                    Id={`${fieldName}.Valore`}
                                    Label={fieldName}
                                    Value={Fields[fieldName].Valore}
                                    Adornment={Fields[fieldName].Tipo == "Percentuale" ? "%" : undefined}
                                    OnChange={(e, val) => setFields({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <TextField multiline fullWidth variant="outlined" id="Note" label={Trad.Trad("Note deroga")} rows={3} rowsMax={5} value={Note} onChange={OnChangeNote} />
                        </Grid>
                    </Grid>
                </form>
            </_Dialog>
            <Grid item>
                <_Button Testo={Trad.Trad("RichiediDeroga")} Icona={<ArrowUpwardIcon />} OnClick={toggle} Default={false} WithWrapper={false} />
            </Grid>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimit/Derogation.tsx